var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.itemClass,attrs:{"id":"signly-video-loader"}},[_c('div',{staticClass:"item"},[_c('fa',{attrs:{"icon":"spinner","size":_vm.iconSize,"spin":""}}),_c('div',{staticClass:"loading-text"},[_c('span',{style:({ 'font-size': _vm.fontSize })},[_vm._v(_vm._s(_vm.$t('videoLoader.loading')))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }